module.exports = __webpack_public_path__ + "static/media/myself.7c3cfe02.jpg";